import * as Yup from "yup";
import { MESSAGE } from "./validationMessage";
import { EMAIL_REGEX, MOBILE_REGEX, NOSPACE_REGEX } from "./constants";

export let email = Yup.string()
  .max(60, "Email should not be longer than 60 characters")
  .required(MESSAGE.REQUIRED)
  .email(MESSAGE.EMAIL)
  .matches(EMAIL_REGEX, MESSAGE.EMAIL);

// let name = Yup.string()
//   .max(60, "Name should not be longer than 60 characters")
//   .required(MESSAGE.REQUIRED)
//   .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE);

let title = Yup.string()
  .max(60, "This field should not be longer than 60 characters")
  .required(MESSAGE.REQUIRED)
  .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE);

// let description = Yup.string()
//   .max(250, "Description should not be longer than 250 characters")
//   .required(MESSAGE.REQUIRED)
//   .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE);

// let question = Yup.string()
//   .max(150, "This field should not be longer than 150 characters")
//   .required(MESSAGE.REQUIRED)
//   .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE);

// let status = Yup.mixed().required(MESSAGE.REQUIRED);

let mobile = Yup.string().required('Phone number is required')
  .matches(MOBILE_REGEX, "Please enter a valid number")
  .test('sum-not-zero', 'Please enter a valid number', value => {
    if (value) {
      const sum = value.split('').reduce((acc, digit) => acc + parseInt(digit, 10), 0);
      return sum !== 0;
    }
    return true;
  })

export const CmsSchema = Yup.object({
  title,
});

// const ALPHANUMERIC_WITH_LETTERS_REGEX = /^(?=.*[a-zA-Z])[A-Za-z0-9]*$/;
export const CategorySchema = Yup.object().shape({
  name: Yup.string()
    .required("Category name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .matches(/^[a-zA-Z0-9 ]+$/, "Only letters and numbers are allowed. No special characters.")
    .min(2, "Category name must be at least 2 characters"),
  image: Yup.mixed().required("Image is required"),
});

export const BidPackageSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
  price: Yup.number()
    .typeError("Price must be a number")
    .required("Price is required")
    .min(1, "Price must be greater than 0")
    .max(10000, "Price must not exceed 10,000")
    .test("price-format", "Invalid price format", (value) => {
      return /^\d+(\.\d{1,2})?$/.test(value);
    }),
  earnBids: Yup.number()
    .typeError("Earn Bids must be a number")
    .required("Earn Bids is required")
    .min(1, "Earn Bids must be greater than 0")
    .max(10000, "Earn Bids must not exceed 10,000")
    .test("earnBids-format", "Invalid Earn Bids format", (value) => {
      return /^\d+(\.\d{1,2})?$/.test(value);
    }),
  description: Yup.array()
    .of(
      Yup.string()
        .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
        .required("Description point cannot be empty")
    )
    .min(1, "At least one description point is required"),
});

export const AdminSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(30, "Name should not be longer than 30 characters")
    .matches(/^[^\s].*[^\s]$|^[^\s]$/, "First name should not have leading or trailing spaces.")
    .matches(/^[a-zA-Z0-9 ]+$/, "Only letters and numbers are allowed. No special characters."),
  email: email,
  phoneNumber: mobile,
})
   
export const userSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First name must be at least 2 characters")
    .max(30, "First name should not be longer than 30 characters")
    .required(MESSAGE.REQUIRED)
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
  lastName: Yup.string()
    .min(2, "First name must be at least 2 characters")
    .max(30, "Last name should not be longer than 30 characters")
    .required(MESSAGE.REQUIRED)
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
  document: Yup.mixed()
    .required(MESSAGE.REQUIRED),

  documentreview: Yup.string().when("$isEdit", {
    is: true,
    then: (schema) =>
      schema
        .required("Document review is required")
        .oneOf(["accept", "reject"], "Invalid option"),
    otherwise: (schema) => schema.notRequired(),
  }),
  email: email,
  phoneNumber: mobile,
})


export const ticketManagementSchema = Yup.object().shape({
  name: Yup.string()
    .required("Lottery name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .matches(/^[a-zA-Z0-9 ]+$/, "Only letters and numbers are allowed. No special characters.")
    .min(2, "Lottery name must be at least 2 characters")
    .max(30, "Lottery name should not be longer than 30 characters"),
  retailerName: Yup.string()
    .required("Retailer name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .matches(/^[a-zA-Z0-9 ]+$/, "Only letters and numbers are allowed. No special characters.")
    .min(2, "Retailer name must be at least 2 characters")
    .max(30, "Retailer name should not be longer than 30 characters"),
  startDate: Yup.string().required("Start date is required"),
  endDate: Yup.string()
    .required("End date is required")
    .test("endDate-check", "End date must be after the start date", function (value) {
      const { startDate } = this.parent;
      const start = new Date(startDate);
      const end = new Date(value);
      return end > start; // End date must be after the start date
    }),
  resultDate: Yup.string()
    .required("Result date is required")
    .test("resultDate-check", "Result date must be after the end date", function (value) {
      const { endDate } = this.parent;
      const end = new Date(endDate);
      const result = new Date(value);
      return result > end; // Result date must be after the end date
    }),
  ticketAmount: Yup.number()
    .typeError("Ticket amount must be a number")
    .required("Ticket amount is required")
    .min(1, "Ticket amount must be greater than 0")
    .max(100000, "Ticket amount must not exceed 100,000"),
  winningAmount: Yup.number()
    .typeError("Winning amount must be a number")
    .required("Winning amount is required")
    .min(1, "Winning amount must be greater than 0")
    .max(100000, "Winning amount must not exceed 100,000"),
  image: Yup.mixed()
    .required("Image is required"),
});



export const ResultDeclareSchema = Yup.object().shape({
  image: Yup.mixed()
    .required("Image is required"),
});